import {useTranslation} from 'react-i18next';

const useTranslator = () => {
    const {t} = useTranslation()
    const translate = (key, params) => {
        return t(key, params)
    }
    return translate
}
export default useTranslator